/**
 * Fiko2DCam Dialog Component
 * 2D CAM Aktivite Seçim Paneli
 *
 * @author FikoYT
 * @version 3.0.0
 */

import { Component, Input, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy, Renderer2 } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { FikoAktiviteProfil } from './aktiviteler/profil/FikoAktiviteProfil';
import { FikoAktiviteCep } from './aktiviteler/cep/FikoAktiviteCep';
import { FikoAktiviteDelik } from './aktiviteler/delik/FikoAktiviteDelik';
import { FikoAktiviteGravur } from './aktiviteler/gravur/FikoAktiviteGravur';

@Component({
  selector: 'fikoyt-2d-cam',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule],
  template: `
    <div class="cam-container">
      <!-- SAYFA 1: Ana Sayfa -->
      <div class="cam-sayfa" *ngIf="aktifSayfa === 'ana'">
        <div class="aktivite-grid ana-grid">
          <button class="aktivite-btn" (click)="yeniOperasyonEkle()" title="Yeni Operasyon Ekle">
            <img src="/simgeler/cam-yeni-operasyon.svg">
            <span>Yeni Op.</span>
          </button>
          <button class="aktivite-btn" (click)="sayfaDegistir('2d-operasyonlar')" title="2D Operasyonlar">
            <img src="/simgeler/cam-2d-operasyonlar.svg">
            <span>2D Op.</span>
          </button>
        </div>
      </div>

      <!-- SAYFA 2: 2D Operasyonlar -->
      <div class="cam-sayfa" *ngIf="aktifSayfa === '2d-operasyonlar'">
        <!-- Geri Butonu -->
        <div class="sayfa-baslik">
          <button class="geri-btn" (click)="sayfaDegistir('ana')" title="Geri">
            <i class="arrow left icon"></i>
          </button>
          <span>2D Operasyonlar</span>
        </div>

        <!-- Aktivite Butonları -->
        <div class="aktivite-grid">
          <button class="aktivite-btn" (click)="aktiviteSec('profil')" title="Profil / Çevre İşleme">
            <img src="/simgeler/cam-profil.svg">
            <span>Profil</span>
          </button>

          <button class="aktivite-btn" (click)="aktiviteSec('cep')" title="Cep İşleme">
            <img src="/simgeler/cam-cep.svg">
            <span>Cep</span>
          </button>

          <div class="aktivite-dropdown">
            <button class="aktivite-btn" (click)="delikMenuToggle($event)" title="Delik İşlemleri">
              <img src="/simgeler/cam-delme.svg">
              <span>Delik ▾</span>
            </button>
          </div>

          <button class="aktivite-btn" (click)="aktiviteSec('gravur')" title="Gravür / Yazı">
            <img src="/simgeler/cam-gravur.svg">
            <span>Gravür</span>
          </button>
        </div>
      </div>

      <!-- Alt Bilgi -->
      <div class="cam-altbilgi">
        {{ aktifSayfa === 'ana' ? 'Operasyon türü seçin' : 'Aktivite seçin' }}
      </div>
    </div>
  `,
  styles: [`
    .cam-container {
      min-width: 180px;
      max-width: 220px;
      background: transparent;
    }

    .cam-sayfa {
      padding: 4px;
    }

    /* Ana Sayfa Grid - 2 sütun */
    .ana-grid {
      grid-template-columns: repeat(2, 1fr) !important;
    }

    /* Sayfa Başlık */
    .sayfa-baslik {
      display: flex;
      align-items: center;
      gap: 6px;
      margin-bottom: 6px;
      padding-bottom: 4px;
      border-bottom: 1px solid rgba(0, 200, 220, 0.3);
      color: rgba(200, 255, 255, 0.9);
      font-size: 10px;
    }

    .geri-btn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      padding: 0;
      border: 1px solid rgba(0, 200, 220, 0.4);
      background: rgba(0, 60, 80, 0.7);
      color: rgba(0, 255, 255, 0.9);
      border-radius: 3px;
      cursor: pointer;
      transition: all 0.15s ease;
    }

    .geri-btn i {
      font-size: 10px;
      margin: 0;
    }

    .geri-btn:hover {
      background: rgba(0, 120, 150, 0.9);
      border-color: rgba(0, 255, 255, 0.7);
    }

    /* Aktivite Grid */
    .aktivite-grid {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 4px;
    }

    .aktivite-btn {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 6px 2px;
      min-height: 48px;
      border: 1px solid rgba(0, 200, 220, 0.3);
      background: rgba(0, 60, 80, 0.6);
      color: rgba(200, 255, 255, 0.9);
      border-radius: 4px;
      cursor: pointer;
      transition: all 0.15s ease;
      font-size: 8px;
      text-align: center;
    }

    .aktivite-btn img {
      width: 24px;
      height: 24px;
      object-fit: contain;
      margin-bottom: 3px;
      filter: drop-shadow(0 0 2px rgba(0, 255, 255, 0.3));
    }

    .aktivite-btn span {
      line-height: 1.1;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 100%;
    }

    .aktivite-btn:hover {
      background: rgba(0, 120, 150, 0.8);
      border-color: rgba(0, 255, 255, 0.7);
      transform: translateY(-1px);
      box-shadow: 0 2px 8px rgba(0, 255, 255, 0.3);
    }

    .aktivite-btn:active {
      transform: translateY(0);
      background: rgba(0, 150, 180, 0.9);
    }

    /* Alt Bilgi */
    .cam-altbilgi {
      padding: 4px 8px;
      background: rgba(0, 0, 0, 0.2);
      border-top: 1px solid rgba(127, 255, 255, 0.15);
      color: rgba(150, 220, 230, 0.6);
      font-size: 8px;
      text-align: center;
    }

    /* Dropdown Container */
    .aktivite-dropdown {
      position: relative;
    }
  `]
})
export class Fiko2DCamComponent implements OnDestroy {

  // Sayfa yönetimi
  aktifSayfa: 'ana' | '2d-operasyonlar' = 'ana';

  // Delik alt menü DOM elementi
  private delikMenuElement: HTMLElement | null = null;
  private clickOutsideListener: (() => void) | null = null;

  // Dialog pattern inputs
  private _anaGosterim: any = null;

  @Input()
  public get anaGosterim(): any {
    return this._anaGosterim;
  }
  public set anaGosterim(v: any) {
    this._anaGosterim = v;
  }

  private _pencere: any;
  private dialogCloseSub: Subscription | null = null;

  @Input()
  public get pencere(): any {
    return this._pencere;
  }
  public set pencere(v: any) {
    this._pencere = v?.instance || v;

    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
      this.dialogCloseSub = null;
    }

    if (this._pencere && this._pencere.onDialogClose) {
      this.dialogCloseSub = this._pencere.onDialogClose.subscribe(() => {
        this.delikMenuKapat();
      });
    }

    this.initComponent();
  }

  @Input() ayarlar: any = {};
  @Input() parametreler: any = {};
  @Input() baslangicAktivite: any = null;   // DialogFiko ayrı input olarak geçer (parametreler nested gelmez)

  constructor(private cd: ChangeDetectorRef, private renderer: Renderer2) {}

  ngOnDestroy(): void {
    if (this.dialogCloseSub) {
      this.dialogCloseSub.unsubscribe();
    }
    this.delikMenuKapat();
  }

  private initComponent(): void {
    if (this.parametreler?.anaGosterim) {
      this._anaGosterim = this.parametreler.anaGosterim;
    }
    // CAM workbench'ten gelen başlangıç aktivitesi (profil/cep/delik/gravur) → otomatik seç
    const ba = this.baslangicAktivite ?? this.parametreler?.baslangicAktivite;
    if (ba && ba !== 'gcode') { try { this.aktiviteSec(ba); } catch { } }
  }

  /**
   * Sayfa değiştir
   */
  sayfaDegistir(sayfa: 'ana' | '2d-operasyonlar'): void {
    this.delikMenuKapat();
    this.aktifSayfa = sayfa;
    this.cd.detectChanges();
  }

  /**
   * Yeni operasyon ekle - Ürün ağacına FikoOperasyon nesnesi ekler
   */
  yeniOperasyonEkle(): void {
    console.log('Yeni Operasyon Ekle');

    // anaGosterim = FikoThreeJsComponent, hem _anaGosterim hem de parametreler'den al
    const anaGosterim = this._anaGosterim || this.parametreler?.anaGosterim;

    if (!anaGosterim) {
      console.warn('anaGosterim bulunamadı');
      return;
    }

    // FikoThreeJsComponent'te sahneler array olarak tutuluyor
    const sahneler = anaGosterim.sahneler;
    const sahne = sahneler?.[0]; // İlk sahneyi al

    if (!sahne) {
      console.warn('Sahne bulunamadı', { anaGosterim, sahneler });
      return;
    }

    // FikoOperasyonlar container'ını bul (SahneFikoAptSimilasyon'da operasyonlar property'si var)
    let operasyonlar = sahne.operasyonlar;

    // Eğer sahne'de direkt yoksa, ürün ağacında ara
    if (!operasyonlar) {
      operasyonlar = this.bulFikoOperasyonlar(sahne);
    }

    if (!operasyonlar) {
      console.warn('FikoOperasyonlar bulunamadı - oluşturuluyor...');
      // Operasyonlar yoksa, sahne children'a bak veya oluştur
      // Şimdilik sadece uyarı ver
      return;
    }

    // Yeni FikoOperasyon ekle
    operasyonlar.ekleFikoperasyon();
    console.log('FikoOperasyon eklendi!');

    // Ağacı güncelle
    anaGosterim.FikoYT?.degisti?.emit();
    anaGosterim.ciz?.();

    // Bildirim gönder
    if (anaGosterim.bildirim) {
      anaGosterim.bildirim.aracKullanildi?.('2D CAM: Yeni Operasyon Eklendi');
    }

    this.cd.detectChanges();
  }

  /**
   * Sahne içinde FikoOperasyonlar container'ını recursive olarak ara
   */
  private bulFikoOperasyonlar(parent: any): any {
    if (!parent?.children) return null;

    for (const child of parent.children) {
      if (child.type === 'Fikoperasyonlar') {
        return child;
      }
      // Recursive ara
      const found = this.bulFikoOperasyonlar(child);
      if (found) return found;
    }
    return null;
  }

  /**
   * Aktif seçili Fikogram'ı bul
   * Önce aktifItem kontrol edilir, sonra ilk Fikogram aranır
   */
  private bulAktifFikogram(): any {
    const anaGosterim = this._anaGosterim || this.parametreler?.anaGosterim;
    if (!anaGosterim) return null;

    // Önce aktifItem'a bak - kullanıcının seçtiği element
    const aktifItem = anaGosterim.aktifItem;
    if (aktifItem) {
      // Aktif item Fikogram ise direkt döndür
      if (aktifItem.type === 'Fikogram') {
        return aktifItem;
      }
      // Aktif item FikoOperasyon ise, içindeki ilk Fikogram'ı al
      if (aktifItem.type === 'Fikoperasyon') {
        const programlar = aktifItem.programlar; // Fikogramlar container
        if (programlar?.liste?.length > 0) {
          return programlar.liste[0];
        }
        // Fikogram yoksa yeni oluştur
        if (programlar) {
          programlar.ekleFikogram?.();
          anaGosterim.FikoYT?.degisti?.emit();
          return programlar.liste?.[0];
        }
      }
    }

    // Sahne içinde ilk Fikogram'ı recursive olarak ara
    const sahneler = anaGosterim.sahneler;
    const sahne = sahneler?.[0];
    if (sahne) {
      return this.bulIlkFikogram(sahne);
    }
    return null;
  }

  /**
   * Sahne içinde ilk Fikogram'ı recursive olarak ara
   */
  private bulIlkFikogram(parent: any): any {
    if (!parent?.children) return null;

    for (const child of parent.children) {
      if (child.type === 'Fikogram') {
        return child;
      }
      // Recursive ara
      const found = this.bulIlkFikogram(child);
      if (found) return found;
    }
    return null;
  }

  /**
   * Delik alt menüsünü aç/kapat
   */
  delikMenuToggle(event: MouseEvent): void {
    event.stopPropagation();

    if (this.delikMenuElement) {
      this.delikMenuKapat();
      return;
    }

    const btn = event.currentTarget as HTMLElement;
    const rect = btn.getBoundingClientRect();

    // Alt menüyü body'ye ekle
    this.delikMenuElement = this.createDelikMenu(rect.bottom + 2, rect.left);
    document.body.appendChild(this.delikMenuElement);

    // Dışarı tıklamada kapat
    setTimeout(() => {
      this.clickOutsideListener = this.renderer.listen('document', 'click', (e: MouseEvent) => {
        if (this.delikMenuElement && !this.delikMenuElement.contains(e.target as Node)) {
          this.delikMenuKapat();
        }
      });
    }, 10);
  }

  /**
   * Delik alt menüsünü kapat
   */
  private delikMenuKapat(): void {
    if (this.delikMenuElement) {
      this.delikMenuElement.remove();
      this.delikMenuElement = null;
    }
    if (this.clickOutsideListener) {
      this.clickOutsideListener();
      this.clickOutsideListener = null;
    }
  }

  /**
   * Delik alt menü DOM elementi oluştur
   */
  private createDelikMenu(top: number, left: number): HTMLElement {
    const menu = document.createElement('div');
    menu.style.cssText = `
      position: fixed;
      top: ${top}px;
      left: ${left}px;
      z-index: 10000;
      display: flex;
      flex-direction: column;
      gap: 2px;
      padding: 4px;
      background: rgba(0, 40, 50, 0.98);
      border: 1px solid rgba(0, 200, 220, 0.6);
      border-radius: 4px;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.5), 0 0 8px rgba(0, 255, 255, 0.2);
      min-width: 100px;
      font-family: inherit;
    `;

    const items = [
      { tip: 'punta', isim: 'Punta', simge: '/simgeler/cam-punta.svg' },
      { tip: 'delme', isim: 'Delme', simge: '/simgeler/cam-delme.svg' },
      { tip: 'rayba', isim: 'Rayba', simge: '/simgeler/cam-rayba.svg' },
      { tip: 'kilavuz', isim: 'Kılavuz', simge: '/simgeler/cam-kilavuz.svg' },
      { tip: 'havsa', isim: 'Havşa', simge: '/simgeler/cam-havsa.svg' },
    ];

    items.forEach(item => {
      const btn = document.createElement('button');
      btn.title = item.isim;
      btn.style.cssText = `
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 5px 8px;
        border: 1px solid rgba(0, 200, 220, 0.2);
        background: rgba(0, 60, 80, 0.7);
        color: rgba(200, 255, 255, 0.9);
        border-radius: 3px;
        cursor: pointer;
        transition: all 0.15s ease;
        font-size: 10px;
        text-align: left;
        white-space: nowrap;
        font-family: inherit;
      `;

      const img = document.createElement('img');
      img.src = item.simge;
      img.style.cssText = `
        width: 18px;
        height: 18px;
        object-fit: contain;
        filter: drop-shadow(0 0 2px rgba(0, 255, 255, 0.3));
      `;

      const span = document.createElement('span');
      span.textContent = item.isim;

      btn.appendChild(img);
      btn.appendChild(span);

      btn.onmouseenter = () => {
        btn.style.background = 'rgba(0, 120, 150, 0.9)';
        btn.style.borderColor = 'rgba(0, 255, 255, 0.7)';
      };
      btn.onmouseleave = () => {
        btn.style.background = 'rgba(0, 60, 80, 0.7)';
        btn.style.borderColor = 'rgba(0, 200, 220, 0.2)';
      };

      btn.onclick = (e) => {
        e.stopPropagation();
        this.aktiviteSec(item.tip);
      };

      menu.appendChild(btn);
    });

    return menu;
  }

  /**
   * Aktivite seçildiğinde çağrılır
   */
  aktiviteSec(tip: string): void {
    // Alt menüyü kapat
    this.delikMenuKapat();
    console.log('2D CAM Aktivite seçildi:', tip);

    const anaGosterim = this._anaGosterim || this.parametreler?.anaGosterim;
    const aktiviteIsimleri: Record<string, string> = {
      'profil': 'Profil / Çevre İşleme',
      'cep': 'Cep İşleme',
      'punta': 'Puntalama',
      'delme': 'Delme Operasyonu',
      'gravur': 'Gravür / Yazı',
      'rayba': 'Raybalama',
      'kilavuz': 'Kılavuz Çekme',
      'havsa': 'Havşa Açma'
    };

    // Aktivite tipine göre işlem yap
    switch (tip) {
      case 'profil':
        this.profilAktiviteEkle();
        break;
      case 'cep':
        this.cepAktiviteEkle();
        break;
      case 'punta':
        this.delikAktiviteEkle('Punta');
        break;
      case 'delme':
        this.delikAktiviteEkle('Delme');
        break;
      case 'rayba':
        this.delikAktiviteEkle('Rayba');
        break;
      case 'kilavuz':
        this.delikAktiviteEkle('Kilavuz');
        break;
      case 'havsa':
        this.delikAktiviteEkle('Havsa');
        break;
      case 'gravur':
        this.gravurAktiviteEkle();
        break;
      default:
        console.log(`${aktiviteIsimleri[tip]} aktivitesi tanınmadı`);
        break;
    }

    // Bildirim gönder
    if (anaGosterim?.bildirim) {
      anaGosterim.bildirim.aracKullanildi?.(`2D CAM: ${aktiviteIsimleri[tip]}`);
    }

    this.cd.detectChanges();
  }

  /**
   * Profil aktivitesi ekle
   */
  private profilAktiviteEkle(): void {
    const anaGosterim = this._anaGosterim || this.parametreler?.anaGosterim;
    if (!anaGosterim) {
      console.warn('anaGosterim bulunamadı');
      return;
    }

    // Sahneyi al
    const sahneler = anaGosterim.sahneler;
    const sahne = sahneler?.[0];
    if (!sahne) {
      console.warn('Sahne bulunamadı');
      return;
    }

    // Aktif Fikogram'ı bul
    const fikogram = this.bulAktifFikogram();
    if (!fikogram) {
      console.warn('Fikogram bulunamadı. Önce bir Operasyon ekleyin veya Fikogram seçin.');
      // Kullanıcıya bilgi ver
      if (anaGosterim?.bildirim) {
        anaGosterim.bildirim.uyari?.('Önce bir Operasyon ekleyin veya mevcut Fikogram seçin');
      }
      return;
    }

    // Yeni FikoAktiviteProfil oluştur
    const profilAktivite = new FikoAktiviteProfil(sahne);

    // Fikogram'a aktiviteyi ekle
    fikogram.ekle(profilAktivite);

    console.log('Profil aktivitesi eklendi:', profilAktivite.name);

    // Ağacı güncelle
    anaGosterim.FikoYT?.degisti?.emit();
    anaGosterim.ciz?.();

    // Yeni eklenen aktiviteyi seç
    anaGosterim.aktifItem = profilAktivite;

    // Dialog'u aç
    profilAktivite.duzenle();
  }

  /**
   * Cep aktivitesi ekle
   */
  private cepAktiviteEkle(): void {
    const anaGosterim = this._anaGosterim || this.parametreler?.anaGosterim;
    if (!anaGosterim) {
      console.warn('anaGosterim bulunamadı');
      return;
    }

    // Sahneyi al
    const sahneler = anaGosterim.sahneler;
    const sahne = sahneler?.[0];
    if (!sahne) {
      console.warn('Sahne bulunamadı');
      return;
    }

    // Aktif Fikogram'ı bul
    const fikogram = this.bulAktifFikogram();
    if (!fikogram) {
      console.warn('Fikogram bulunamadı. Önce bir Operasyon ekleyin veya Fikogram seçin.');
      if (anaGosterim?.bildirim) {
        anaGosterim.bildirim.uyari?.('Önce bir Operasyon ekleyin veya mevcut Fikogram seçin');
      }
      return;
    }

    // Yeni FikoAktiviteCep oluştur
    const cepAktivite = new FikoAktiviteCep(sahne);

    // Fikogram'a aktiviteyi ekle
    fikogram.ekle(cepAktivite);

    console.log('Cep aktivitesi eklendi:', cepAktivite.name);

    // Ağacı güncelle
    anaGosterim.FikoYT?.degisti?.emit();
    anaGosterim.ciz?.();

    // Yeni eklenen aktiviteyi seç
    anaGosterim.aktifItem = cepAktivite;

    // Dialog'u aç
    cepAktivite.duzenle?.();
  }

  /**
   * Delik aktivitesi ekle
   */
  private delikAktiviteEkle(delikTipi: 'Punta' | 'Delme' | 'Rayba' | 'Kilavuz' | 'Havsa'): void {
    const anaGosterim = this._anaGosterim || this.parametreler?.anaGosterim;
    if (!anaGosterim) {
      console.warn('anaGosterim bulunamadı');
      return;
    }

    // Sahneyi al
    const sahneler = anaGosterim.sahneler;
    const sahne = sahneler?.[0];
    if (!sahne) {
      console.warn('Sahne bulunamadı');
      return;
    }

    // Aktif Fikogram'ı bul
    const fikogram = this.bulAktifFikogram();
    if (!fikogram) {
      console.warn('Fikogram bulunamadı. Önce bir Operasyon ekleyin veya Fikogram seçin.');
      if (anaGosterim?.bildirim) {
        anaGosterim.bildirim.uyari?.('Önce bir Operasyon ekleyin veya mevcut Fikogram seçin');
      }
      return;
    }

    // Yeni FikoAktiviteDelik oluştur
    const delikAktivite = new FikoAktiviteDelik(sahne);
    delikAktivite.delikTipi = delikTipi;

    // Delik tipine göre takım tipini ayarla
    switch (delikTipi) {
      case 'Punta':
        delikAktivite.takim.takimTipi = 'Punta';
        break;
      case 'Delme':
        delikAktivite.takim.takimTipi = 'Matkap';
        break;
      case 'Rayba':
        delikAktivite.takim.takimTipi = 'Rayba';
        break;
      case 'Kilavuz':
        delikAktivite.takim.takimTipi = 'Kilavuz';
        break;
      case 'Havsa':
        delikAktivite.takim.takimTipi = 'Havsa';
        break;
    }

    // Fikogram'a aktiviteyi ekle
    fikogram.ekle(delikAktivite);

    console.log(`Delik aktivitesi (${delikTipi}) eklendi:`, delikAktivite.name);

    // Ağacı güncelle
    anaGosterim.FikoYT?.degisti?.emit();
    anaGosterim.ciz?.();

    // Yeni eklenen aktiviteyi seç
    anaGosterim.aktifItem = delikAktivite;

    // Dialog'u aç
    delikAktivite.duzenle?.();
  }

  /**
   * Gravür aktivitesi ekle
   */
  private gravurAktiviteEkle(): void {
    const anaGosterim = this._anaGosterim || this.parametreler?.anaGosterim;
    if (!anaGosterim) {
      console.warn('anaGosterim bulunamadı');
      return;
    }

    // Sahneyi al
    const sahneler = anaGosterim.sahneler;
    const sahne = sahneler?.[0];
    if (!sahne) {
      console.warn('Sahne bulunamadı');
      return;
    }

    // Aktif Fikogram'ı bul
    const fikogram = this.bulAktifFikogram();
    if (!fikogram) {
      console.warn('Fikogram bulunamadı. Önce bir Operasyon ekleyin veya Fikogram seçin.');
      if (anaGosterim?.bildirim) {
        anaGosterim.bildirim.uyari?.('Önce bir Operasyon ekleyin veya mevcut Fikogram seçin');
      }
      return;
    }

    // Yeni FikoAktiviteGravur oluştur
    const gravurAktivite = new FikoAktiviteGravur(sahne);

    // Fikogram'a aktiviteyi ekle
    fikogram.ekle(gravurAktivite);

    console.log('Gravür aktivitesi eklendi:', gravurAktivite.name);

    // Ağacı güncelle
    anaGosterim.FikoYT?.degisti?.emit();
    anaGosterim.ciz?.();

    // Yeni eklenen aktiviteyi seç
    anaGosterim.aktifItem = gravurAktivite;

    // Dialog'u aç
    gravurAktivite.duzenle?.();
  }
}
